var React = require('react');

function IconCrewTalentSupport (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"data-name":"Rectangle 71","fill":"none","d":"M0 0h78v78H0z"}))),React.createElement("g",{"data-name":"Group 160","key":1},React.createElement("g",{"data-name":"Group 159","clipPath":"url(#a)"},[React.createElement("path",{"data-name":"Path 4","d":"M39 78A39 39 0 100 39a39 39 0 0039 39","fill":"#10457a","key":0}),React.createElement("path",{"data-name":"Path 5","d":"M43.966 36.728a9.825 9.825 0 004.637-8.2 9.976 9.976 0 00-19.944 0 9.828 9.828 0 004.467 8.1c-7.5 2.408-12.954 9.816-12.954 18.566a1.212 1.212 0 001.211 1.21h34.025a1.21 1.21 0 001.21-1.21 19.311 19.311 0 00-12.652-18.466","fill":"#fff","key":1})]))]);
}

IconCrewTalentSupport.defaultProps = {"width":"78","height":"78","viewBox":"0 0 78 78"};

module.exports = IconCrewTalentSupport;

IconCrewTalentSupport.default = IconCrewTalentSupport;
